import { atom } from "jotai";
import { IAssetCategory } from "../services/assetServices";

export const assetCategoriesAtom = atom<IAssetCategory[]>([]);
export const assetCategoriesLoadedAtom = atom<boolean>(false);

